/** Product Sync — the standalone page: scope picker + the embeddable
 *  ProductSyncForm (which owns the catalogue fetch, the product table, the run
 *  options and the launch). The setup wizard hosts the same form with a fixed
 *  scope and an injected launch path.
 */
import { Box } from '@mui/material';
import { useState } from 'react';

import { PageHeader } from '@/components/PageHeader';

import { PendingReviewChip } from './catalogue/PendingReviewChip';
import { ProductSyncForm } from './ProductSyncForm';
import { SyncScopePicker, initialSyncScope, type SyncScope } from './SyncScopePicker';

// Pure helpers moved with the form; re-exported so existing importers/tests
// keep their import path.
export {
  AI_CONFIRM_THRESHOLD,
  credentialsConfigUrl,
  differingFacets,
  expandableProductIds,
  needsAiConfirmation,
} from './ProductSyncForm';

export function ProductSyncPage() {
  const [scope, setScope] = useState<SyncScope>(initialSyncScope);

  return (
    <Box>
      <PageHeader
        title="Product Sync"
        helpStory="product-sync"
        titleAdornment={<PendingReviewChip scope={scope} />}
      />

      <ProductSyncForm
        scope={scope}
        scopeSlot={
          <SyncScopePicker
            value={scope}
            onChange={setScope}
            requiredFeature="product_list"
          />
        }
      />
    </Box>
  );
}
